import React, { useState, useEffect, useRef } from "react";
import "./registarkontrola.css";
import { baseRequest } from "../../../axiosconfig";
import Loading from "../../loading";
import DropDown from "../../elements/dropDown";
import { useReactToPrint } from "react-to-print";
import { formatDeadline } from "../../../utils/deadlineFormat";

const riskColors = {
  nizak: "#B0E0E6",
  srednji: "#FFD700",
  visok: "#FF5C5C",
};

const sourceFilterList = [
  { id: "mapa_procesa", name: "Mapa procesa" },
  { id: "formular_rizika", name: "Formular rizika" },
];

function ControlsTable({ controls }) {
  return (
    <div className="table-scroll">
    <table className="registar-kontrola-table">
      <thead>
        <tr>
          <th style={{ width: "50px" }}>R.BR.</th>
          <th style={{ width: "110px" }}>IZVOR</th>
          <th style={{ width: "160px" }}>POSLOVNI PROCES</th>
          <th style={{ width: "140px" }}>PROCEDURA</th>
          <th>OPIS KONTROLE/MERE</th>
          <th style={{ width: "160px" }}>POVEZANI RIZIK</th>
          <th style={{ width: "90px" }}>NIVO RIZIKA</th>
          <th style={{ width: "150px" }}>ODGOVORNO LICE</th>
          <th style={{ width: "100px" }}>ROK</th>
          <th style={{ width: "110px" }}>STATUS</th>
        </tr>
      </thead>
      <tbody>
        {controls.length === 0 && (
          <tr>
            <td colSpan={10} className="registar-kontrola-empty">
              Nema evidentiranih kontrolnih aktivnosti.
            </td>
          </tr>
        )}
        {controls.map((c, i) => (
          <tr key={c.id}>
            <td>{i + 1}</td>
            <td>{c.source_label}</td>
            <td>{c.process_name}</td>
            <td>{c.procedure_name || "—"}</td>
            <td>{c.control_description}</td>
            <td>{c.risk_name || "—"}</td>
            <td
              style={
                c.risk_level
                  ? { backgroundColor: riskColors[c.risk_level], color: "#000" }
                  : undefined
              }
            >
              {c.risk_level || "—"}
            </td>
            <td>{c.responsible || "—"}</td>
            <td>{formatDeadline(c.deadline)}</td>
            <td>{c.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
}

function RegistarKontrola() {
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useState([]);
  const [sourceFilter, setSourceFilter] = useState({ id: "all", name: "ALL" });
  const [processFilter, setProcessFilter] = useState({ id: "all", name: "ALL" });
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    setLoading(true);
    baseRequest
      .get("/control_register")
      .then((res) => {
        setControls(res.data.controls || []);
        setLoading(false);
      })
      .catch(() => {
        setControls([]);
        setLoading(false);
      });
  }, []);

  const processList = [...new Set(controls.map((c) => c.process_name).filter(Boolean))].map(
    (name) => ({ id: name, name })
  );

  const filtered = controls.filter((c) => {
    if (sourceFilter.id !== "all" && c.source !== sourceFilter.id) return false;
    if (processFilter.id !== "all" && c.process_name !== processFilter.id) return false;
    return true;
  });

  return (
    <div className="registar-kontrola">
      <div className="processes-header registar-kontrola-header">
        <DropDown
          dropDownStyle={{ borderRight: "1px solid var(--mainColor)", width: "30%" }}
          height={"49px"}
          list={sourceFilterList}
          onChange={({ value }) => setSourceFilter(value)}
          selectedValue={sourceFilter?.name}
          isFilter={true}
        />
        <DropDown
          dropDownStyle={{ borderRight: "1px solid var(--mainColor)", width: "40%" }}
          height={"49px"}
          list={processList}
          onChange={({ value }) => setProcessFilter(value)}
          selectedValue={processFilter?.name}
          isFilter={true}
        />
        <span className="registar-kontrola-total">
          Ukupno kontrola: {filtered.length}
        </span>
        <div style={{ marginRight: "10px", marginLeft: "auto" }}>
          <button className="add-btn-large" onClick={handlePrint}>
            <img alt="" src="/images/printer.png"></img>
          </button>
        </div>
      </div>

      <h2 className="registar-kontrola-title">REGISTAR KONTROLNIH AKTIVNOSTI</h2>
      <ControlsTable controls={filtered} />

      <div style={{ display: "none" }}>
        <div ref={componentRef} className="registar-kontrola-print">
          <h2>REGISTAR KONTROLNIH AKTIVNOSTI</h2>
          <p>Datum: {new Date().toLocaleDateString("sr-RS")}</p>
          <ControlsTable controls={filtered} />
        </div>
      </div>

      <Loading isLoading={loading} />
    </div>
  );
}

export default RegistarKontrola;
